<template>
  <div v-if="user">
    <div class="field">
      <label class="label">Title</label>
      <div class="control">
        <input class="input" type="text" v-model="title" />
      </div>
    </div>
    <div class="field">
      <label class="label">Body</label>
      <div class="control">
        <textarea class="textarea" rows="4" v-model="body"></textarea>
      </div>
    </div>
    <div class="field">
      <div class="control">
        <button
          :class="['button', 'is-success', isSending ? 'is-loading' : '']"
          :disabled="!title || !body"
          @click="sendPush"
        >
          Send Push Notification
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { toast } from "@/utils/toast";

export default {
  name: "UserNotificationsTab",
  props: {
    userData: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      title: "",
      body: "",
      isSending: false,
    };
  },
  computed: {
    ...mapState(["selectedUser"]),
    user() {
      return this.userData || this.selectedUser;
    },
  },
  methods: {
    async sendPush() {
      if (!this.user || !this.user.id || !this.title || !this.body) return;

      this.isSending = true;
      try {
        const response = await this.$http.post("mobile-devices/send-push", {
          userId: this.user.id,
          title: this.title,
          body: this.body,
        });

        if (response && response.status === 200) {
          toast.success("Push notification sent");
          this.title = "";
          this.body = "";
        }
        // Non-2xx responses (e.g. 404 when the user has no registered device)
        // already surface a toast via the global http response interceptor.
      } catch (error) {
        console.error("Error sending push notification:", error);
      } finally {
        this.isSending = false;
      }
    },
  },
};
</script>

<style></style>
